import { formatDistanceToNowStrict } from 'date-fns';
import enUSLocale from 'date-fns/locale/en-US';

const formatDistanceLocale = {
  lessThanXSeconds: '{{count}}s',
  xSeconds: '{{count}}s',
  halfAMinute: '30s',
  lessThanXMinutes: '{{count}}m',
  xMinutes: '{{count}}m',
  aboutXHours: '{{count}}h',
  xHours: '{{count}}h',
  xDays: '{{count}}d',
  aboutXWeeks: '{{count}}w',
  xWeeks: '{{count}}w',
  aboutXMonths: '{{count}}m',
  xMonths: '{{count}}m',
  aboutXYears: '{{count}}y',
  xYears: '{{count}}y',
  overXYears: '{{count}}y',
  almostXYears: '{{count}}y',
};

export const formatDistance = (
  token: keyof typeof formatDistanceLocale,
  count: string,
) => {
  const result = (formatDistanceLocale[token] as any).replace('{{count}}', count);
  return result;
};

const locale = { ...enUSLocale, formatDistance };

export const distanceToNowShort = (time: number | string, suffix = '') => {
  const timeNumeric = typeof time === 'number' ? time : Date.parse(time);
  // increase by a second to eliminate 'in 0 seconds'
  const mod = timeNumeric > Date.now() ? 1000 : -1000;
  return `${formatDistanceToNowStrict(timeNumeric + mod, {
    addSuffix: true,
    locale,
  })}${suffix}`;
};
